import React from 'react';
import {
    Button
} from '@rebrandly/styleguide'
const EmailShareButton = ({ url, buttonProps = {} }) => {
    if (!url) {
        return null;
    }

    const mailtoParams = new URLSearchParams();
    mailtoParams.set('body', url || '');

    const mailtoLink = 'mailto:' + (mailtoParams.toString() ? '?' + mailtoParams.toString() : '');

    const onClick = (e) => {
        e.preventDefault();
        window.location.href = mailtoLink;
    };

    return (
        <Button
            onClick={onClick}
            {...buttonProps}
        >
            {buttonProps.children}
        </Button>
    );
};

export default EmailShareButton;